import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import { Slider } from 'design-system';
import { useState } from 'react';

// models
import CatalogItem from 'src/models/helperTypes/CatalogItem';
import { CoverageCustomizable } from 'src/models/Quotation/CoverageCuztomization';

// funtions
import { getCoverageImageDetail } from 'src/functions/getCoverageImage';

const useStyles = makeStyles(() => ({
  coverageText: {
    fontSize: 15,
    fontWeight: 400,
    color: '#555659',
  },
  coverageValue: {
    fontSize: 17,
    fontWeight: 900,
  },
}));

type Props = {
  coverage: CoverageCustomizable;
  onChangeCoverageLimit: (code: string, value: number) => void;
  disableSlider: boolean;
};

const CoverageSlider = ({
  coverage,
  disableSlider,
  onChangeCoverageLimit,
}: Props): JSX.Element => {
  const classes = useStyles();
  const { code, name, options, defaultValue } = coverage;
  const [value, setValue] = useState(defaultValue.Value);
  const [valueText, setValueText] = useState(defaultValue.Text);
  const image = getCoverageImageDetail(code);

  const handleChange = (val: CatalogItem): void => {
    setValue(val.Value);
    setValueText(val.Text);
    const selecedValue = coverage.limits.find(
      (limit) => limit.id === val.Value,
    );
    const limitValue = selecedValue?.value || 0;
    onChangeCoverageLimit(coverage.code, limitValue);
  };

  return (
    <>
      <Grid
        item
        xs={12}
        style={{ paddingLeft: 30 }}
        data-testid="information-container"
      >
        <Grid container alignItems="center">
          <Box sx={{ width: 40, paddingTop: 5, paddingRight: 13 }}>
            <img src={image.src} alt={image.alt} />
          </Box>
          <Box flexGrow={1} display="flex" justifyContent="space-between">
            <Typography className={classes.coverageText}>{name}</Typography>
            <Typography className={classes.coverageValue}>
              {valueText}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid item xs={12} style={{ paddingLeft: 50 }}>
        <Slider
          data-testid="customizable-deductible-slider"
          inputId="sales-web-button-customizable-coverage-slider"
          inputName="customizable-coverage-slider"
          inputLabel=""
          defaultValue={value}
          onChange={handleChange}
          labelType="ends"
          options={options}
          isDisabled={disableSlider}
        />
      </Grid>
    </>
  );
};

export default CoverageSlider;
